module.exports = __webpack_public_path__ + "static/media/WEBnegro_20.f4917272.png";